import { useCallback } from "react";
import { Table, Text, Button } from "@mantine/core";
import { IconRestore } from "@tabler/icons-react";
import { getMaterialLabel } from "../accessioning/specimenConstants";

interface RecoverSpecimenRowProps {
  id: string;
  number: string;
  source: string | null;
  material: string | null;
  isLoading: boolean;
  disabled: boolean;
  onRecover: (id: string, number: string) => void;
}

export function RecoverSpecimenRow({
  id,
  number,
  source,
  material,
  isLoading,
  disabled,
  onRecover,
}: RecoverSpecimenRowProps) {
  const handleClick = useCallback(() => {
    onRecover(id, number);
  }, [id, number, onRecover]);

  return (
    <Table.Tr>
      <Table.Td>
        <Text fw={600}>{number}</Text>
      </Table.Td>
      <Table.Td>{source || "—"}</Table.Td>
      <Table.Td>{getMaterialLabel(material) || "—"}</Table.Td>
      <Table.Td>
        <Button
          size="xs"
          variant="light"
          color="teal"
          leftSection={<IconRestore size={14} />}
          loading={isLoading}
          disabled={disabled}
          onClick={handleClick}
        >
          Restore
        </Button>
      </Table.Td>
    </Table.Tr>
  );
}
